import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "discountType",
    "percentField",
    "dollarField",
    "percentInput",
    "dollarInput",
    "dayCheckbox"
  ]

  connect() {
    this.toggleDiscountFields()
    this.updateDayPills()
  }

  toggleDiscountFields() {
    const checkedRadio = this.discountTypeTargets.find(el => el.checked)
    const selectedType = checkedRadio ? checkedRadio.value : "percent"

    if (selectedType === "percent") {
      this.percentFieldTarget.classList.remove("d-none")
      this.dollarFieldTarget.classList.add("d-none")
      this.percentInputTarget.required = true
      this.percentInputTarget.disabled = false
      this.dollarInputTarget.required = false
      this.dollarInputTarget.disabled = true
      this.dollarInputTarget.value = ""
    } else {
      this.percentFieldTarget.classList.add("d-none")
      this.dollarFieldTarget.classList.remove("d-none")
      this.percentInputTarget.required = false
      this.percentInputTarget.disabled = true
      this.dollarInputTarget.required = true
      this.dollarInputTarget.disabled = false
      this.percentInputTarget.value = ""
    }
  }

  // Triggered when day button pills are clicked
  toggleDay(event) {
    event.preventDefault()
    const pill = event.currentTarget
    const day = pill.dataset.day
    const checkbox = this.dayCheckboxTargets.find(cb => cb.value === day)

    if (checkbox) {
      checkbox.checked = !checkbox.checked
      checkbox.dispatchEvent(new Event("change"))
      this.updateDayPills()
    }
  }

  // Updates pill classes based on checkbox checked status
  updateDayPills() {
    this.dayCheckboxTargets.forEach(cb => {
      const day = cb.value
      const pill = this.element.querySelector(`[data-day="${day}"]`)
      if (pill) {
        if (cb.checked) {
          pill.classList.remove("btn-outline-secondary")
          pill.classList.add("btn-primary", "text-white")
        } else {
          pill.classList.remove("btn-primary", "text-white")
          pill.classList.add("btn-outline-secondary")
        }
      }
    })
  }
}
